"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CancelAPButton = _interopRequireDefault(require("../../common/CancelAPButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./BulkCancelButtonsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('bulk-cancel-buttons');
var BulkCancelButtonsComponent = function BulkCancelButtonsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var openOrders = props.openOrders,
    buyOpenOrders = props.buyOpenOrders,
    sellOpenOrders = props.sellOpenOrders,
    cancelAllOrders = props.cancelAllOrders,
    cancelBuyOrders = props.cancelBuyOrders,
    cancelSellOrders = props.cancelSellOrders;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('label')
  }, t('Cancel'), ":"), /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
    customClass: baseClasses(),
    text: t('Sells'),
    disabled: sellOpenOrders.length === 0,
    onClick: cancelSellOrders
  }), /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
    customClass: baseClasses(),
    text: t('Buys'),
    disabled: buyOpenOrders.length === 0,
    onClick: cancelBuyOrders
  }), /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
    customClass: baseClasses(),
    text: t('All'),
    disabled: openOrders.length === 0,
    onClick: cancelAllOrders
  }));
};
BulkCancelButtonsComponent.propTypes = {
  cancelAllOrders: _propTypes["default"].func.isRequired,
  cancelBuyOrders: _propTypes["default"].func.isRequired,
  cancelSellOrders: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = BulkCancelButtonsComponent;